export default __webpack_public_path__ + "static/media/text.4c3c3d90.svg";